import React, { useEffect, useState } from 'react';
import PreventionTemplateList from 'containers/pages/prevention/PreventionTemplateList';
import { useIntl } from 'react-intl';
import messages from 'messages';
import { useContextMenu } from 'contexts/ContextMenuProvider';
import AddSessionModal from 'containers/pages/sessions/AddSessionModal';
import { useParams } from 'react-router-dom';
import { ButtonExpandable } from 'components/button';
import AddTemplateModal from 'containers/pages/prevention/AddTemplateModal';

const OverviewTemplatesTab = () => {
  const intl = useIntl();
  const { entityId } = useParams();
  const [sessionModal, setSessionModal] = useState(null);
  const [templateModal, setTemplateModal] = useState(null);

  const { addActionButton, clearAllContext } = useContextMenu();

  useEffect(() => {
    addActionButton(
      <ButtonExpandable
        tabIndex={0}
        onClick={() => setTemplateModal(true)}
        label={intl.formatMessage(messages.buttonSessionsAddTemplate)}
      />
    );

    return () => {
      clearAllContext();
    };
  }, []);

  return (
    <>
      <PreventionTemplateList
        onUse={template =>
          setSessionModal({
            title: intl.formatMessage(messages.preventionModalAddTitle, {
              type: template.preventionType,
              sessionExists: Boolean(template.name),
              isTemplate: true,
              session: template.name,
              span: chunks => (
                <span className="c-card__header-highlight">{chunks}</span>
              )
            }),
            type: 'prevention',
            isCopy: true,
            session: template
          })
        }
      />

      {sessionModal && (
        <AddSessionModal
          entityId={entityId}
          title={sessionModal.title}
          type={sessionModal.type}
          isCopy={sessionModal.isCopy}
          session={sessionModal.session}
          onClose={() => {
            setSessionModal(false);
          }}
        />
      )}

      {templateModal && (
        <AddTemplateModal
          entityId={entityId}
          onClose={() => {
            setTemplateModal(false);
          }}
        />
      )}
    </>
  );
};

export default OverviewTemplatesTab;
